import { VStack, Spacing, colors } from "goi_common";
import { Box } from "@chakra-ui/react";
import { ReactNode } from "react";
import HomeV4PrimaryButton from "./HomeV4PrimaryButton";

interface HomeV4CTASectionProps {
  title?: ReactNode;
  buttonText?: string;
  onClick?: () => void;
  background?: string;
  buttonBackground?: string;
  disabled?: boolean;
}

export default function HomeV4CTASection({
  title = (
    <>
      준비가 빠를수록
      <br />
      줄어드는 장례비용
    </>
  ),
  buttonText = "고이 상조 자세히 보기",
  onClick,
  background = colors.gray50,
  buttonBackground = colors.orange650,
  disabled = false,
}: HomeV4CTASectionProps) {
  return (
    <VStack
      width="100%"
      padding="56px 20px"
      background={background}
      alignItems="center"
    >
      <Box className="subtitle_21_sb" color={colors.gray900} textAlign="center">
        {title}
      </Box>

      <Spacing gap={24} />

      <HomeV4PrimaryButton
        onClick={onClick}
        background={disabled ? colors.orange400 : buttonBackground}
        disabled={disabled}
      >
        {buttonText}
      </HomeV4PrimaryButton>
    </VStack>
  );
}
